/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type BusinessAddressDTO = {
    businessTradingName?: string;
    compoundName?: string;
    country?: string;
    documentContent: string;
    documentType: BusinessAddressDTO.documentType;
    landmark?: string;
    localGovernmentArea?: string;
    mimeExt: string;
    state?: string;
    streetAddress?: string;
    verificationStatus?: BusinessAddressDTO.verificationStatus;
};

export namespace BusinessAddressDTO {

    export enum documentType {
        INTERNATIONAL_PASSPORT = 'INTERNATIONAL_PASSPORT',
        VOTERS_CARD = 'VOTERS_CARD',
        NATIONAL_ID_CARD = 'NATIONAL_ID_CARD',
        DRIVERS_LICENSE = 'DRIVERS_LICENSE',
        ECG_GHANA_ELECTRICITY = 'ECG_GHANA_ELECTRICITY',
        TELEPHONE_BILL = 'TELEPHONE_BILL',
        GHANA_WATER_BILL = 'GHANA_WATER_BILL',
        SOLE_PROPRIETORSHIP = 'SOLE_PROPRIETORSHIP',
        PARTNERSHIP = 'PARTNERSHIP',
        LIMITED_UNLIMITED_LIABILITY = 'LIMITED_UNLIMITED_LIABILITY',
        EXTERNAL_COMPANY = 'EXTERNAL_COMPANY',
        LIMITED_LIABILITY = 'LIMITED_LIABILITY',
        CLUBS_SOCIETIES_ASSOCIATIONS = 'CLUBS_SOCIETIES_ASSOCIATIONS',
        GHANA_CARD = 'GHANA_CARD',
        HOME_ADDRESS = 'HOME_ADDRESS',
        DIRECTORS_NAME = 'DIRECTORS_NAME',
        RESIDENT_PERMIT = 'RESIDENT_PERMIT',
        NON_CITIZEN_CARD = 'NON_CITIZEN_CARD',
        GIPC_CERTIFICATE = 'GIPC_CERTIFICATE',
        SELFIE = 'SELFIE',
        BVN = 'BVN',
        ELECTRICITY_BILL = 'ELECTRICITY_BILL',
        WASTE_BILL = 'WASTE_BILL',
        WATER_BILL = 'WATER_BILL',
        HOUSE_RENT_RECEIPT = 'HOUSE_RENT_RECEIPT',
        TENANCY_AGREEMENT = 'TENANCY_AGREEMENT',
        LAND_USE_CHARGE = 'LAND_USE_CHARGE',
        OTHERS = 'OTHERS',
    }

    export enum verificationStatus {
        PENDING = 'PENDING',
        SUCCESS = 'SUCCESS',
        FAILED = 'FAILED',
    }


}

